/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_DurationInputs */



/**
* | output |
* | --- |
* | "Video Duration" |
*
* @param {Video_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_duration = /** @type {((inputs?: Video_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée de la vidéo")
	if (locale === "de") return /** @type {LocalizedString} */ ("Videodauer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durata del video")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Продолжительность видео")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duración del video")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("视频时长")
	if (locale === "ja") return /** @type {LocalizedString} */ ("動画の長さ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("वीडियो की अवधि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração do vídeo")
	return /** @type {LocalizedString} */ ("Video Duration")
});